import { render } from "./SmartProjectIcon.vue?vue&type=template&id=6f9d74be&lang=html"
import script from "./SmartProjectIcon.vue?vue&type=script&lang=js"
export * from "./SmartProjectIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__